import { call, put, takeLatest } from "redux-saga/effects";
import { getCrawledPost, patchCrawledPost, patchCrawledPostFailed, patchCrawledPostSucess, setCrawledPost } from "../slices/CrawledPostManagementSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { CrawledPostParam, PutCrawledPostParam } from "@/Interfaces/I_postManagement";
import { fetchCrawledPostApi, patchCrawledPostApi } from "@/Axios/api/crawledPostManagement";
import { AxiosResponse } from "axios";
import { message } from "antd";

const clearWaterfallCrawledPostsCache = () => {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.removeItem('waterfallV2CrawledPosts');
    window.sessionStorage.removeItem('waterfallV2CrawledPosts');
  } catch (error) {
    console.warn('Cannot clear waterfallV2CrawledPosts cache', error);
  }
};

function* handleGetCrawledPost(action: PayloadAction<CrawledPostParam>) {
  try {
    const data: AxiosResponse = yield call(fetchCrawledPostApi, action.payload);
    yield put(setCrawledPost(data))
  } catch (e) {
    message.error({
      content: `Cannot Get Post! ${e}`,
      duration: 3,
      style: {
          marginTop: '120px',
        },
    })
  }
}

function* handlePatchCrawledPost(action: PayloadAction<PutCrawledPostParam>) {
  try {
    yield call(patchCrawledPostApi, action.payload)
    if (action.payload.action === 'DISABLE') {
      clearWaterfallCrawledPostsCache();
    }
    message.success({
      content: 'Post Updated!',
      duration: 3,
      style: {
        marginTop: '120px',
      },
    });
    const payload = {
      postUuid: action.payload.postUuid,
      disabled: action.payload.action === "ENABLE" ? false : true
    }
    yield put(patchCrawledPostSucess(payload))
  } catch (e) {
    message.error({
      content: `Cannot update post: ${e}`,
      duration: 3,
      style: {
        marginTop: '120px',
      },
    })
    yield put(patchCrawledPostFailed(e))
  }
}

export function* watchGetCrawledPost() {
  yield takeLatest(getCrawledPost.type, handleGetCrawledPost);
}

export function* watchPatchCrawledPost() {
  yield takeLatest(patchCrawledPost.type, handlePatchCrawledPost);
}